import React from 'react';
import { cn } from '@/lib/utils';
import { Loader } from 'lucide-react';

const TableButtonMock = ({
  className = '',
  disabled = false,
  isLoading = false,
  isActive = false,
  iconOnly = false,
  children,
  ...props
}: {
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  isActive?: boolean;
  /** Square 30×30 variant with no text label — pair with a Tooltip for the label. */
  iconOnly?: boolean;
  children: React.ReactNode;
}) => {
  const buttonStyles = cn(
    'transition flex items-center gap-1 justify-center relative text-xs leading-[16px] rounded-md font-semibold box-border border border-neutral-200 text-neutral-900 hover:bg-neutral-100 [&>svg]:text-neutral-700 [&>svg]:size-3.5 h-[30px]',
    iconOnly ? 'w-[30px] p-0' : 'px-2.5 py-1',
    {
      'text-[transparent] hover:bg-[transparent] [&>svg]:text-[transparent]':
        isLoading,
      'text-basic-disabled-main bg-basic-disabled-bg hover:bg-basic-disabled-bg border-none':
        disabled,
      'bg-neutral-100': isActive,
    },
    className,
  );

  return (
    <div className={buttonStyles} {...props}>
      {isLoading && (
        <div className="absolute bottom-0 top-0 z-10 mx-auto flex items-center justify-center">
          <Loader className={cn('size-4 animate-spin text-neutral-900')} />
        </div>
      )}
      {children}
    </div>
  );
};

export default TableButtonMock;
